import ConsoleControlPanel from "./ConsoleControl";

export { default as AudioControl } from "./Audio";
export { default as SperatorControl } from "./Seprator";
export { default as BadgeControl } from "./Badge";
export { default as RaiseHandControl } from "./RaiseHand";
export { default as ReactionControl } from "./Reaction";
export { default as SoundSettings } from "./SoundSettings";
export { default as SpeakerControl } from "./Speaker";
export { default as VideoControl } from "./Video";
export { default as ChatControl } from "./Chat";
export { default as LogoutControl } from "./Logout";
export { default as MenuControl } from "./Menu";
export { default as NotepadControl } from "./Notepad";
export { default as ParticipantControl } from "./Participant";
export { default as ShareScreenControl } from "./ShareScreen";
export { default as VisitingCardControl } from "./VisitingCard";

export default ConsoleControlPanel;
